import { uniq } from 'lodash';

export function getUniqueByKey<T, K extends keyof T>(array: T[], key: K): T[K][] {
    return uniq(array.map((item) => item[key]));
}
